import Translate from "../../translate/Translate";
import { CustomMultiFilterButton } from "../button/CustomMultiFilterButton";

export default function TransactionStatusFilterButton({ currentValues, setValues }) {
    const values = [
        { label: Translate("revenue.transactionStatus.allStatus"), value: "all" },
        { label: Translate("revenue.transactionStatus.succeed"), value: "Succeed" },
        { label: Translate("revenue.transactionStatus.failed"), value: "Failed" },
        { label: Translate("revenue.transactionStatus.voided"), value: "Voided" },
        { label: Translate("revenue.transactionStatus.paymentExpired"), value: "Payment Expired" },
    ];

    return (
        <CustomMultiFilterButton
            icon={currentValues.includes("all") ? "receipt_lines" : "receipt_lines_active"}
            currentValues={currentValues}
            setValues={setValues}
            values={values}
            multiText={"Result"}
            iconWidth={"11.7px"}
            iconHeight={"13.5px"}
        />
    );
}
